import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import bgGradient from '@/assets/images/bg-gradient.webp';
import loginMockup from '@/assets/images/login-mockup.png';
import kanbuLogo from '@/assets/images/logo-black.svg';
import { useBoundStore } from '@/store/store';

export const Route = createFileRoute('/_authLayout')({
  component: AuthLayout,
  beforeLoad: async () => {
    if (useBoundStore.getState().jwt) {
      throw redirect({
        to: '/inbox',
      });
    }
  },
});

export function AuthLayout() {
  return (
    <div className='flex h-screen flex-col bg-background 2xl:flex-row'>
      <div className='absolute z-10 block size-full 2xl:relative 2xl:w-1/2'>
        <div className='relative flex h-screen items-center justify-center 2xl:justify-end'>
          <img
            src={bgGradient}
            alt='Kanbu'
            className='size-full object-cover'
          />
          <img
            src={loginMockup}
            alt='Kanbu'
            className='absolute hidden w-full max-w-[560px] px-12 py-6 2xl:mr-44 2xl:block'
          />
        </div>
      </div>
      <div className='relative z-20 flex min-h-0 flex-1 w-full flex-col items-center overflow-y-auto px-6 py-8 sm:px-12 2xl:w-1/2 2xl:items-start 2xl:justify-center 2xl:bg-slate-100 2xl:pl-44'>
        <div className='relative my-auto flex w-full max-w-[520px] flex-col items-center rounded-lg bg-white p-8 shadow-lg sm:p-12 2xl:p-16'>
          <div className='mb-8 mt-4'>
            <img src={kanbuLogo} alt='Kanbu logo' className=' h-12' />
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
